import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from './Header';
import SVGIcon from '../components/SVGIcon';
import LoadingContainer from '../components/LoadingContainer';
import { pushRoute } from '../utilities/helpers';
import { setCredentials, deleteCredentials } from '../utilities/localStorage';
import { authenticateUser, setNotfirstToSelectPage } from '../store/actions/auth-actions';

const SelectAccount = () => {

  const auth = useSelector(state => state.auth);
  const accounts = useSelector(state => state.auth.accounts);
  const firstName = useSelector(state => state.auth.firstName);
  const lastName = useSelector(state => state.auth.lastName);
  const currentAccountIndex = useSelector(state => state.auth.currentAccountIndex);
  const expiresAt = useSelector(state => state.auth.expiresAt);

  const dispatch = useDispatch();

  const [selectedIdx, selectChange] = useState(currentAccountIndex);
  const [selectedToken, tokenChange] = useState('');


  const sortedAccountsArray = () => {

    const sortAlphabetically = (a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }

    if (Array.isArray(accounts) && accounts.length > 1) {

      let superAdmin = [];
      let owner = [];
      let admin = [];
      let user = [];

      accounts.forEach((item) => {
        switch (item.roles[0]) {
          case 'SuperAdmin':
            superAdmin.push(item);
            break;
          case 'Owner':
            owner.push(item)
            break;
          case 'Admin':
            admin.push(item)
            break;
          case 'User':
            user.push(item)
            break;
          default:
            user.push(item)
            break;
        }
      })

      superAdmin.sort(sortAlphabetically);
      owner.sort(sortAlphabetically);
      admin.sort(sortAlphabetically);
      user.sort(sortAlphabetically);

      return superAdmin.concat(owner, admin, user);
    } else {
      return [];
    }

  }

  const sortedArray = sortedAccountsArray();




  useEffect(() => {
    if (sortedArray.length > 0) {
      tokenChange(sortedArray[selectedIdx].token)
    }
  }, [accounts]);

  const selectItem = (idx) => {
    selectChange(idx)
    if (sortedArray.length > 0) {
      tokenChange(sortedArray[idx].token)
    }

  }

  const loginWithSelectedAccount = () => {

    dispatch(authenticateUser(`Bearer ${selectedToken}`, selectedIdx))
    dispatch(setNotfirstToSelectPage());
    deleteCredentials();
    setCredentials({
      token: selectedToken,
      firstName: firstName,
      lastName: lastName,
      accounts: sortedArray,
      currentAccountIndex: selectedIdx,
      firstToSelectPage: false,
      expiresAt
    });
    // when select the new account. Loading the client data again.
    pushRoute('/loading');
  }




  return (
    <div className="ReportHome">
      <Header />
      <main>
        <div className="CriteriaModal_wrapper" style={{ width: '55rem' }}>
          <div className="CriteriaModal_inner">
            <SVGIcon icon="user" />
            <h2 className="CriteriaModal_title" style={{ marginBottom: '3rem' }}>Select account</h2>

            <LoadingContainer
              className="content-card"
              loading={false}
            >
              <div className={`CriteriaModal_select-account${sortedAccountsArray().length > 2 ? `_multiple-account` : ``}`}>
                <div className="CriteriaModal_select-account_inner">
                  {sortedAccountsArray().map((item, idx) => {
                    return (
                      <div
                        key={idx}
                        className={`CriteriaModal_select-account_account-item${idx === selectedIdx ? `_selected` : ''}`}
                        onClick={() => selectItem(idx)}
                      >
                        <span className="CriteriaModal_select-account_label_text">Type: </span>
                        <span className="CriteriaModal_select-account_value"> {item.type.charAt(0).toUpperCase() + item.type.slice(1)} </span>

                        <span className="CriteriaModal_select-account_label_text">Name: </span>
                        <span className="CriteriaModal_select-account_value">{item.name} </span>

                        <span className="CriteriaModal_select-account_label_text">Permission: </span>
                        <span className="CriteriaModal_select-account_value">{item.roles.length > 0 ? item.roles[0] : 'User'} </span>
                        <div className="CriteriaModal_select-account_radio">
                          <label className="radio_container">
                            <input type="radio" checked={idx === selectedIdx} readOnly />
                            <span className="radio_checkmark"></span>
                          </label>
                        </div>

                      </div>
                    )

                  })}
                </div>
              </div>
            </LoadingContainer>

            <div className="CriteriaModal_bottom-row">
              <span className="CriteriaModal_bottom-row_left" />
              <div className="CriteriaModal_bottom-row_right">
                <button
                  onClick={() => loginWithSelectedAccount()}
                  className="CriteriaModal_search-button"
                  type="button"
                >
                  Confirm
              </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default SelectAccount;
